/**
 * Alpine component: referralPromo
 * Overlay "Porta un amico" — mostra messaggio di benvenuto e salva
 * il codice referral in sessionStorage per il flusso di acquisto.
 */
export function registerReferralPromo(Alpine) {
    Alpine.data('referralPromo', () => ({
        open: false,

        init() {
            const code = this.$el.dataset.code;
            if (code) {
                sessionStorage.setItem('ik_referral_code', code);
                // Aggiorna lo store cart se già inizializzato
                if (Alpine.store('cart')) {
                    Alpine.store('cart').referralCode = code;
                }
            }

            // Apri overlay con un breve delay per permettere l'animazione
            this.$nextTick(() => {
                this.open = true;
                document.body.style.overflow = 'hidden';
            });

            // Chiudi con Escape
            this._handleEscape = (e) => {
                if (e.key === 'Escape') this.close();
            };
            document.addEventListener('keydown', this._handleEscape);
        },

        close() {
            this.open = false;
            document.body.style.overflow = '';
            document.removeEventListener('keydown', this._handleEscape);
        },

        destroy() {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', this._handleEscape);
        },
    }));
}
